import gql from 'graphql-tag';

export const GET_VENDOR_OPPORTUNITIES_LIST = gql`
  query GetVendorOpportunitiesList($input: VendorOpportunitiesListInput!) {
    vendorOpportunitiesList(input: $input) {
      error
      success
      total
      data {
        vendorOpportunityId
        dynamicsVendorOpportunityId
        createdOn
        salesRepresentativeId
        salesManagerId
        financeManagerId
        applicationStage
        transactionStage
        invoiceTotal
        equipmentDescription
        invoiceStatus
        statusDetail
        displayStatus
        vendorProfileId
        sourceVendorProfileId

        # Entities
        potentialCustomer {
          name
        }
        salesRepresentative {
          fullName
        }
        salesManager {
          fullName
        }
        financeManager {
          fullName
        }
        partnerProfile {
          partnerLogo
        }
        creditApplication {
          creditApplicationId
          firstName
          lastName
          applicationType
          entityType
          applyingFor
          creditApplicationOwner {
            firstName
            lastName
            pc
            signatureDate
          }
        }
        lead {
          inboundDealType
        }
        businessProcessFlowsView {
          flowId
          department
          departmentName
          currentStageId
          currentStageName
        }
        creditTiersResult {
          runtimeOutput
          highestTierPassed
          highestTierColor
        }
        location {
          locationId
          locationName
        }
      }
    }
  }
`;
